import { render, staticRenderFns } from "./MortgageAgreement.vue?vue&type=template&id=67fb1a11"
import script from "./MortgageAgreement.vue?vue&type=script&lang=js"
export * from "./MortgageAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports